/* eslint-disable max-len */
export default {
    title: 'Legal notice',
    text: [
        'This website supplies information about Lemlock.',
        '<strong>Head office and postal address</strong>',
        '<strong>Sagiton Sp. z o.o.</strong>',
        'Fabryczna 19<br/> 53-609 Wrocław<br/> Poland',
        'Mobile: +48 71 758 00 70<br/> E-mail: contact@sagiton.pl',
        'VAT-ID: PL8943044096<br/> TAX: 022069799<br/> Company number 0000449601 (Register of Entrepreneurs of the National Court Register)<br/> Managing Directors: Marcin Michalski, Grzegorz Mąkosa, Adam Końca',
        'Lemlock is trademark of Sagiton Sp. z o.o.<br/> The product name and logo quoted or displayed on this website are trademark or service marks of their respective owners.'
    ]
};



// WEBPACK FOOTER //
// ./src/i18n/en/legal.js